'use client';
import { ReactNode, useId } from 'react';
import cn from 'classnames';

import './Button.style.scss';

import TooltipMessage, {
  TooltipPosition,
  tooltipMessageId
} from '@/components/common/TooltipMessage/TooltipMessage';

type ButtonProps = {
  className?: string;
  children: ReactNode;
  variant?:
    | 'dark'
    | 'icon'
    | 'light'
    | 'pink'
    | 'pink-400'
    | 'red'
    | 'underline';
  onClick?: (e: any) => void | Promise<void>;
  size?: 'large' | 'small' | 'small-bold' | 'xsmall';
  disabled?: boolean;
  rounded?: boolean;
  type?: 'submit' | 'button';
  style?: React.CSSProperties;
  tooltip?: string;
  tooltipPosition?: TooltipPosition;
};

function Button(props: ButtonProps) {
  const {
    className = '',
    variant = 'dark',
    children,
    size = 'large',
    onClick,
    disabled = false,
    rounded = false,
    type = 'button',
    style,
    tooltip,
    tooltipPosition = 'bottom'
  } = props;
  const tooltipId = useId();
  const button = (
    <button
      className={cn(
        'Button',
        variant,
        size,
        className,
        { rounded },
        { disabled }
      )}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      aria-describedby={tooltip ? tooltipMessageId(tooltipId) : undefined}
    >
      {children}
    </button>
  );

  return tooltip ? (
    <span
      className={cn('TooltipAnchor', 'ButtonTooltipAnchor', {
        'TooltipAnchor--disabled': disabled
      })}
      data-tooltip-id={tooltipId}
    >
      {button}
      <TooltipMessage
        id={tooltipId}
        content={tooltip}
        position={tooltipPosition}
      />
    </span>
  ) : (
    button
  );
}

export default Button;
